interface ZoomableImageProps {
  src?: string;
  alt?: string;
}

export const ZoomableImage = (props: ZoomableImageProps) => {
  if (!props.src) {
    return '';
  }

  const imageHtml = `
    <figure class="inline-block w-full flex-col px-4">
      <button
        type="button"
        class="bg-transparent w-full border-0 p-0 "
        aria-label="Zoom in image"
        onclick="
          const modal = this.parentElement.querySelector('.zoom-modal');
          if (modal) {
            modal.style.display = 'flex';
            document.body.style.overflow = 'hidden';
          }
        "
      >
        <img
          src="${props.src}"
          alt="${props.alt || ''}"
          class="min-h-[200px] max-h-[300px] w-auto rounded-sm text-black cursor-zoom-in object-contain transition-opacity opacity-100 hover:opacity-90"
          onerror="this.parentElement.style.display='none'"
          onload="
            this.classList.remove('opacity-0');
            this.classList.add('opacity-100');
          "
        />
      </button>
      ${
        props.alt
          ? `
        <figcaption class="mt-1 text-center text-sm text-gray-600 line-clamp-2">
          ${props.alt}
        </figcaption>
      `
          : ''
      }
      <div
        class="zoom-modal fixed inset-0 z-50 hidden items-center justify-center bg-black/80"
        onclick="
          this.style.display = 'none';
          document.body.style.overflow = '';
        "
      >
        <div
          class="relative max-h-[90vh] max-w-[90vw] overflow-auto p-4"
          onclick="event.stopPropagation()"
        >
          <img
            src="${props.src}"
            alt="${props.alt || ''}"
            class="max-h-[85vh] w-auto object-contain"
          />
          ${
            props.alt
              ? `
            <div class="mt-4 text-center text-sm text-white">
              ${props.alt}
            </div>
          `
              : ''
          }
          <button
            type="button"
            class="absolute right-2 top-2 rounded-full bg-black/50 p-2 text-white hover:bg-black/70"
            onclick="
              this.closest('.zoom-modal').style.display = 'none';
              document.body.style.overflow = '';
            "
            aria-label="Close zoom view"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </figure>
  `;

  return imageHtml;
};

export default ZoomableImage;
